const currencySymbols = {
  USD: '$',
  CAD: 'CA$',
  AUD: 'A$',
  NZD: 'NZ$',
  HKD: 'HK$',
  MXN: 'MX$',
  SGD: 'SG$',
  COP: 'CO$',

  GBP: '£',
  EUR: '€',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'Kr',
  YEN: '¥',
  AED: 'د.إ',
  CHF: 'Fr',
  ZAR: 'R',
  INR: '₹',
  KRW: '₩',
  TRY: '₺',
  PLN: 'zł',
  MYR: 'RM',
  CZK: 'Kč',
  BRL: 'R$',
  ILS: '₪',
  GEL: '₾',
};

export function getCurrencySymbol(
  currency?: string | null,
): string | undefined {
  const value = (currency ?? 'USD').toUpperCase();

  return currencySymbols[value];
}
